module.exports = __webpack_public_path__ + "static/img/55555.69c01b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pro/park/55555.png
// module id = sAwg
// module chunks = 0